module.exports = __webpack_public_path__ + "img/b1.9f70af34.png";